export function isRestrictedMode(): boolean {
  try {
    return JSON.parse(localStorage.getItem('restrictedMode') || 'false') === true;
  } catch {
    return false;
  }
}

/** Feature keys hidden from vendors whose registration is not yet approved. */
export const RESTRICTED_FEATURES = new Set([
  'invoice',
  'invoiceHistory',
  'purchaseHistory',
  'changeRequests',
]);
